import { Fragment } from 'react';
import { chainflipLinks } from '@chainflip/utils/consts';
import classNames from 'classnames';
import { Link } from '@/shared/components/atoms/Link';
import useNetworkInfo from '@/shared/hooks/useNetworkInfo';

export type ChainflipApp = 'swap' | 'lp' | 'auctions' | 'explorer';

const appLinks: { app: ChainflipApp; label: string; href: string | undefined }[] = [
  { app: 'swap', label: 'Swap', href: process.env.NEXT_PUBLIC_SWAPPING_URL },
  { app: 'lp', label: 'LP app', href: process.env.NEXT_PUBLIC_LP_URL },
  { app: 'auctions', label: 'Auctions', href: process.env.NEXT_PUBLIC_STAKING_URL },
  { app: 'explorer', label: 'Explorer', href: process.env.NEXT_PUBLIC_EXPLORER_URL },
];

const Separator = () => (
  <span className="font-aeonikRegular text-12 leading-4 text-cf-light-2">•</span>
);

export const Footer = ({
  app,
  legalLinks,
  className,
}: {
  app: ChainflipApp;
  legalLinks?: { label: string; href: string }[];
  className?: string;
}) => (
  <footer
    className={classNames(
      'flex w-full justify-center border-t border-cf-gray-3-5 bg-cf-gray-2',
      className,
    )}
  >
    <div className="flex w-full flex-col gap-y-6 px-4 pb-5 pt-6 2xl:container md:h-[74px] md:flex-row md:items-center md:justify-between md:px-8 md:py-0">
      <div className="flex flex-col gap-y-0.5 text-14 leading-[18px]">
        <span className="font-aeonikMedium text-cf-light-3">
          Operated by Crosschain Association
        </span>
        <span className="text-cf-light-2">{useNetworkInfo()}</span>
      </div>
      <div className="flex flex-col gap-y-2 font-aeonikMedium text-14 leading-[18px] md:flex-row md:items-center md:gap-x-3 md:gap-y-0">
        <div
          className={classNames(
            'flex flex-wrap items-center gap-x-1',
            legalLinks && 'md:border-r md:border-cf-gray-4 md:pr-3',
          )}
        >
          <Link href={chainflipLinks.website} target="_blank">
            About Chainflip
          </Link>
          {appLinks
            .flatMap(({ app: linkedApp, label, href }) =>
              linkedApp === app || !href ? [] : [{ label, href }],
            )
            .map(({ label, href }) => (
              <Fragment key={label}>
                <Separator />
                <Link href={href} target="_blank">
                  {label}
                </Link>
              </Fragment>
            ))}
        </div>
        {legalLinks && (
          <div className="flex flex-wrap items-center gap-x-1">
            {legalLinks.map(({ label, href }, index) => (
              <Fragment key={label}>
                {index > 0 && <Separator />}
                <Link href={href} color="light">
                  {label}
                </Link>
              </Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  </footer>
);
